<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Clientes</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Administrar Pagos de Clientes</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>ADMINISTRAR PAGOS DE CLIENTES</strong>
      </span>
    </div>
    <div class="col-12">
      <div class="card p-fondo">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2">
            <span><strong>SUCURSAL:</strong></span>
            <Dropdown
              v-model="sucursalSelected"
              :options="sucursales"
              optionLabel="nombre"
              optionValue="id"
              @change="BuscarFiltro"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-4">
            <span><strong>CLIENTE:</strong></span>
            <Dropdown
              v-model="clienteSelected"
              :options="clientes"
              optionLabel="nombre"
              optionValue="id"
              :filter="true"
              @change="BuscarFiltro"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>PROVINCIA/UBICACIÓN: </strong></span>
            <Dropdown
              v-model="provinciaSelected"
              :options="provincias"
              optionLabel="nombre_municipio"
              optionValue="id"
              :filter="true"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <span><strong>TIPO DE PAGO: </strong></span>
            <Dropdown v-model="tipoPagoSelected" :options="tipo_pagos" optionLabel="nombre" optionValue="id">
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>FECHA INICIO: </strong></span>
            <InputText v-model="fecha_inicio" placeholder="Fecha Inicio" type="date" />
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>FECHA FIN: </strong></span>
            <InputText v-model="fecha_fin" placeholder="Fecha Fin" type="date" />
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>ESTADO: </strong></span>
            <Dropdown v-model="estadoSelected" :options="estados" optionLabel="label" optionValue="value"> </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>USUARIO: </strong></span>
            <Dropdown v-model="usuarioSelected" :options="usuarios" optionLabel="name" optionValue="id" :filter="true">
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>VENCIMIENTO: </strong></span>
            <Dropdown
              v-model="vencimientoSelected"
              :options="estadosVencimiento"
              optionLabel="label"
              optionValue="value"
              @change="BuscarFiltro"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <span><strong>ACCIONES: </strong></span>
            <Button
              label="APLICAR FILTROS"
              icon="pi pi-search"
              class="p-button-indo mr-2"
              v-tooltip.top="'Aplicar los filtros'"
              :loading="enviando"
              :disabled="enviando"
              @click="BuscarFiltro"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="pago_clientes"
        key="id"
        :value="pago_clientes"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm"
        :filters="buscar"
        responsive="true"
        stripedRows
        showGridlines
        :lazy="true"
        :paginator="true"
        :rows="porPagina"
        :totalRecords="totalRegistros"
        @page="onPageChange"
        :rowsPerPageOptions="[50, 100, 200, 500]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Pagos de Clientes"
        selectionMode="single"
        @row-dblclick="NuevoPagoCliente($event.data)"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar Pagos de CLientes..." />
            </span>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'Cliente PagoDescargarEXCEL' in auth.user.permissions"
                label="EXCEL"
                type="button"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success mr-2"
                v-tooltip.top="'Exportar a Excel'"
                :loading="exportando"
                @click="exportPagosClient()"
              />
              <Button
                v-if="
                  'WhatsApp Enviar' in auth.user.permissions &&
                  pago_clientes.length > 0 &&
                  sucursalSelected > 0 &&
                  pago_clientes.some((p) => p.estado === 2 && p.saldo > 0)
                "
                label="WhatsApp"
                type="button"
                icon="pi pi-whatsapp"
                class="p-button-success"
                v-tooltip.top="'Enviar Recordatorio de Pagos Pendientes'"
                @click="enviarWhatsApp()"
                :loading="enviando_whatsapp"
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>

        <template #empty>
          <span
            class="flex align-items-center justify-content-center"
            style="background-color: #f8d7da; padding: 5px; border-radius: 5px; color: #721c24"
          >
            Debe aplicar filtros para ver resultados en la tabla!</span
          >
        </template>

        <Column field="venta_id" header="Nº.VENTA" class="text-center"></Column>

        <Column field="nombre_usuario" header="USUARIO">
          <template #body="{ data }">
            <div v-tooltip.top="data.nombre_usuario" class="texto-truncado">
              {{ data.nombre_usuario.split(' ')[0] }}
            </div>
          </template>
        </Column>

        <Column field="cliente_nombre" header="CLIENTE">
          <template #body="{ data }">
            <div v-tooltip.top="data.cliente_nombre" class="texto-truncado">
              {{ data.cliente_nombre }}
            </div>
          </template>
        </Column>

        <Column field="nombre_municipio" header="UBICACIÓN">
          <template #body="{ data }">
            <div v-tooltip.top="data.nombre_municipio" class="texto-truncado">
              {{ data.nombre_municipio }}
            </div>
          </template>
        </Column>

        <Column field="fecha_pago" header="F.PAGO">
          <template #body="{ data }">
            <div style="font-size: 0.8rem">{{ formatearFechaCorta(data.fecha_pago) }}</div>
          </template>
        </Column>

        <!-- COLUMNA DE FECHA VENCIMIENTO - SOLO SI HAY FECHAS -->
        <Column v-if="mostrarColumnaFechaVencimiento" field="fecha_limite_descuento" header="F.VENC.">
          <template #body="{ data }">
            <div v-if="data.descuento_condicional && data.fecha_limite_descuento">
              <Tag
                :severity="getEstadoVencimiento(data.fecha_limite_descuento).severity"
                :icon="getEstadoVencimiento(data.fecha_limite_descuento).icon"
                :value="formatearFechaCorta(data.fecha_limite_descuento)"
                v-tooltip.top="getEstadoVencimiento(data.fecha_limite_descuento).tooltip"
                style="font-size: 0.75rem; padding: 0.2rem 0.4rem"
              />
            </div>
            <div v-else class="text-center text-500" style="font-size: 0.75rem">-</div>
          </template>
        </Column>

        <Column class="text-right" field="total_venta" header="T.VENTA">
          <template #body="{ data }">
            <div style="font-weight: bold; font-size: 0.85rem">
              {{ convertirNumeroGermanicFormat(data.total_venta) }}
            </div>
          </template>
        </Column>

        <!-- COLUMNA EFECTIVO - SOLO SI HAY EFECTIVO -->
        <Column v-if="mostrarColumnaEfectivo" class="text-right" field="a_cuenta_efectivo" header="EFEC.">
          <template #body="{ data }">
            <div style="font-size: 0.85rem">{{ convertirNumeroGermanicFormat(data.a_cuenta_efectivo) }}</div>
          </template>
        </Column>

        <!-- COLUMNA TRANSFERENCIA - SOLO SI HAY TRANSFERENCIAS -->
        <Column v-if="mostrarColumnaTransferencia" class="text-right" field="a_cuenta_metodo_pago" header="TRANS.">
          <template #body="{ data }">
            <div style="font-size: 0.85rem">{{ convertirNumeroGermanicFormat(data.a_cuenta_metodo_pago) }}</div>
          </template>
        </Column>

        <Column class="text-right" field="saldo" header="SALDO">
          <template #body="{ data }">
            <div>
              <span
                :class="data.saldo == 0 ? 'text-success' : 'text-danger'"
                style="font-weight: bold; font-size: 0.85rem"
              >
                {{ convertirNumeroGermanicFormat(data.saldo) }}
              </span>
              <div v-if="data.recargo_incumplimiento > 0" class="mt-1">
                <Tag severity="danger" icon="pi pi-exclamation-circle" style="font-size: 0.7rem">
                  Recargo: {{ convertirNumeroGermanicFormat(data.recargo_incumplimiento) }}
                </Tag>
              </div>
            </div>
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span
              :class="'product-badge ' + claseEstado[data.estado]"
              style="font-size: 0.75rem; padding: 0.2rem 0.5rem"
            >
              {{ estadoTexto(data.estado) }}
            </span>
          </template>
        </Column>

        <Column header="ACCIONES">
          <template #body="slotProps">
            <div class="flex gap-1">
              <Button
                v-if="slotProps.data.saldo > 0"
                icon="pi pi-money-bill"
                class="p-button-success p-button-sm"
                v-tooltip.top="'Pagar'"
                @click="NuevoPagoCliente(slotProps.data)"
              />
              <Button
                class="p-button-sm"
                icon="pi pi-ellipsis-v"
                v-tooltip.top="'Ver Acciones'"
                @click="$refs['menu' + slotProps.data.id].toggle($event)"
              />
            </div>
            <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)"> </Menu>
          </template>
        </Column>
      </DataTable>
    </div>

    <PagoCliente
      :show="pagoClienteDialog"
      :pago_cliente="{ ...pago_cliente }"
      @closeModal="cerrarModalPagoCliente"
      @actualizarListado="actualizarListado"
    />

    <Dialog
      v-model:visible="modalRecargoVisible"
      :modal="true"
      :closable="false"
      :style="{ width: '500px' }"
      header="⚠️ Recargo por Incumplimiento"
    >
      <div class="flex flex-column align-items-center p-3">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #f59e0b; margin-bottom: 1rem"></i>

        <h3 class="mt-2 mb-3 text-center">{{ clienteSeleccionado?.cliente_nombre }}</h3>

        <div class="surface-100 border-round p-3 w-full mb-3">
          <div class="flex justify-content-between mb-2">
            <span class="text-600">Nº Venta:</span>
            <span class="font-bold">{{ clienteSeleccionado?.venta_id }}</span>
          </div>
          <div class="flex justify-content-between mb-2">
            <span class="text-600">Total Venta (sin descuento):</span>
            <span class="font-bold"
              >Bs.
              {{
                convertirNumeroGermanicFormat(
                  parseFloat(clienteSeleccionado?.total_venta || 0) +
                    parseFloat(clienteSeleccionado?.monto_descuento_vigente || 0)
                )
              }}</span
            >
          </div>
          <div class="flex justify-content-between mb-2">
            <span class="text-success">Descuento Aplicado:</span>
            <span class="text-success font-bold"
              >- Bs.
              {{ convertirNumeroGermanicFormat(parseFloat(clienteSeleccionado?.monto_descuento_vigente || 0)) }}</span
            >
          </div>
          <div class="flex justify-content-between mb-2">
            <span class="text-600">Total con Descuento:</span>
            <span class="font-bold">Bs. {{ convertirNumeroGermanicFormat(clienteSeleccionado?.total_venta) }}</span>
          </div>
          <Divider class="my-2" />
          <div class="flex justify-content-between mb-2">
            <span class="text-600">Saldo Actual:</span>
            <span class="font-bold">Bs. {{ convertirNumeroGermanicFormat(clienteSeleccionado?.saldo) }}</span>
          </div>
          <div class="flex justify-content-between mb-3">
            <span class="text-orange-600">Recargo por Incumplimiento:</span>
            <span class="font-bold text-orange-600"
              >+ Bs.
              {{ convertirNumeroGermanicFormat(parseFloat(clienteSeleccionado?.monto_descuento_vigente || 0)) }}</span
            >
          </div>
          <Divider class="my-2" />
          <div class="flex justify-content-between">
            <span class="text-700 font-bold">Nuevo Saldo Total:</span>
            <span class="font-bold text-red-600" style="font-size: 1.2rem">
              Bs.
              {{
                convertirNumeroGermanicFormat(
                  parseFloat(clienteSeleccionado?.saldo || 0) +
                    parseFloat(clienteSeleccionado?.monto_descuento_vigente || 0)
                )
              }}
            </span>
          </div>
        </div>

        <p class="text-center text-600 text-sm mb-0">
          Por incumplimiento del plazo, se perderá el descuento y se cobrará el monto original de la venta.
        </p>
      </div>

      <template #footer>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="modalRecargoVisible = false"
          :disabled="aplicandoRecargo"
        />
        <Button
          label="SI, APLICAR"
          icon="pi pi-check"
          class="p-button-info"
          @click="confirmarRecargo"
          :loading="aplicandoRecargo"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="modalConfirmacionWhatsAppVisible"
      :modal="true"
      :closable="true"
      :style="{ width: '600px' }"
      header="Confirmar Envío de Recordatorios de Pago"
    >
      <div class="flex flex-column p-3">
        <div class="flex align-items-center mb-4">
          <i class="pi pi-whatsapp" style="font-size: 3rem; color: #25d366; margin-right: 1rem"></i>
          <div>
            <h3 class="mt-0 mb-1">Recordatorio de Pagos Pendientes</h3>
            <p class="mt-0 text-600">Se enviará un recordatorio a los siguientes clientes:</p>
          </div>
        </div>

        <div class="surface-100 border-round p-3 mb-3" style="max-height: 350px; overflow-y: auto">
          <div class="flex justify-content-between mb-2 pb-2" style="border-bottom: 2px solid #dee2e6">
            <span class="font-bold">Total de mensajes a enviar:</span>
            <span class="font-bold text-primary">{{ clientesValidosWhatsApp.length }}</span>
          </div>

          <div
            v-for="(cliente, index) in clientesValidosWhatsApp"
            :key="index"
            class="flex justify-content-between align-items-start py-2"
            style="border-bottom: 1px solid #e9ecef"
          >
            <div class="flex-1">
              <div class="font-bold">{{ cliente.cliente_nombre }}</div>
              <div class="text-sm text-600">
                Venta #{{ cliente.venta_id }} - Saldo: Bs. {{ convertirNumeroGermanicFormat(cliente.saldo) }}
              </div>
              <div v-if="cliente.fecha_limite_descuento" class="text-xs mt-1">
                <Tag
                  :severity="getEstadoVencimientoSeverity(cliente.fecha_limite_descuento)"
                  :value="'Vence: ' + formatearFechaCorta(cliente.fecha_limite_descuento)"
                  style="font-size: 0.7rem"
                />
              </div>
            </div>
            <div class="text-right">
              <div class="text-600 text-sm">{{ cliente.telefono || 'Sin teléfono' }}</div>
            </div>
          </div>

          <div
            v-if="clientesSinTelefonoWhatsApp.length > 0"
            class="mt-3 p-3"
            style="background-color: #fff3cd; border-radius: 5px"
          >
            <div class="flex align-items-center mb-2">
              <i class="pi pi-exclamation-triangle text-orange-600 mr-2"></i>
              <span class="font-bold text-orange-600"
                >Clientes sin teléfono ({{ clientesSinTelefonoWhatsApp.length }})</span
              >
            </div>
            <div v-for="(cliente, index) in clientesSinTelefonoWhatsApp" :key="index" class="text-sm text-600">
              - {{ cliente.cliente_nombre }} (Venta #{{ cliente.venta_id }})
            </div>
          </div>
        </div>

        <div class="surface-200 border-round p-3">
          <div class="flex align-items-start">
            <i class="pi pi-info-circle text-blue-500 mr-2 mt-1"></i>
            <div class="text-sm text-600">
              <p class="mt-0 mb-2"><strong>El recordatorio incluirá:</strong></p>
              <ul class="mt-0 mb-0 pl-3">
                <li>Número de venta y fecha</li>
                <li>Total de venta, monto abonado y saldo pendiente</li>
                <li v-if="hayClientesConVencimiento">⚠️ Advertencia de vencimiento de descuento (si aplica)</li>
                <li>Teléfono de contacto</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="modalConfirmacionWhatsAppVisible = false"
          :disabled="enviando_whatsapp"
        />
        <Button
          label="SI, ENVIAR RECORDATORIOS"
          icon="pi pi-send"
          class="p-button-success"
          @click="confirmarEnvioWhatsAppPagos"
          :loading="enviando_whatsapp"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import ClienteService from '@/service/ClienteService'
import SucursalService from '@/service/SucursalService'
import PagoCliente from '@/module/clientes/PagoCliente.vue'
import TipoPagoService from '@/service/TipoPagoService'
import MetodoPagoService from '@/service/MetodoPagoService'
import PagoClienteService from '@/service/PagoClienteService'
import VentaService from '@/service/VentaService'
import { useAuth } from '@/stores'

export default {
  components: {
    PagoCliente
  },
  data() {
    return {
      pago_clientes: [],
      pago_cliente: {},
      sucursales: [{ id: 0, nombre: 'TODAS' }],
      sucursalSelected: 0,
      clientes: [{ id: 0, nombre: 'TODOS' }],
      clienteSelected: 0,
      tipo_pagos: [{ id: 0, nombre: 'TODOS' }],
      tipoPagoSelected: 0,
      metodo_pagos: [{ id: 0, nombre: 'TODOS' }],
      metodoPagoSelected: 0,
      fecha_inicio: null,
      fecha_fin: null,
      enviando: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        }
      },
      pagoClienteDialog: false,
      claseEstado: ['', 'status-instock', 'status-outofstock', 'status-instock'],
      estados: [
        { label: 'TODOS', value: 0 },
        { label: 'PAGADO', value: 1 },
        { label: 'PENDIENTE', value: 2 }
      ],
      estadoSelected: 2,
      provincias: [{ id: 0, nombre_municipio: 'TODAS' }],
      provinciaSelected: 0,
      exportando: false,
      enviando_whatsapp: false,
      usuarioSelected: 0,
      usuarios: [{ id: 0, name: 'TODOS' }],
      modalRecargoVisible: false,
      clienteSeleccionado: null,
      aplicandoRecargo: false,

      estadosVencimiento: [
        { label: 'TODOS', value: 0 },
        { label: 'VENCIDOS', value: 1 },
        { label: 'VENCE ESTA SEMANA', value: 2 },
        { label: 'VENCE EN 2 SEMANAS', value: 3 },
        { label: 'VENCE EN 3 SEMANAS', value: 4 },
        { label: 'VIGENTES (MÁS DE 3 SEMANAS)', value: 5 }
      ],
      vencimientoSelected: 0,
      totalesGenerales: {
        total_venta: 0,
        total_efectivo: 0,
        total_transferencias: 0,
        total_saldo: 0,
        total_recargos: 0
      },
      paginaActual: 1,
      porPagina: 50,
      totalRegistros: 0,
      modalConfirmacionWhatsAppVisible: false,
      clientesValidosWhatsApp: [],
      clientesSinTelefonoWhatsApp: []
    }
  },
  computed: {
    mostrarColumnaEfectivo() {
      return this.pago_clientes.some((p) => p.a_cuenta_efectivo > 0)
    },
    mostrarColumnaTransferencia() {
      return this.pago_clientes.some((p) => p.a_cuenta_metodo_pago > 0)
    },
    mostrarColumnaFechaVencimiento() {
      return this.pago_clientes.some((p) => p.descuento_condicional && p.fecha_limite_descuento)
    },
    hayClientesConVencimiento() {
      return this.clientesValidosWhatsApp.some((c) => c.fecha_limite_descuento)
    }
  },
  clienteService: null,
  sucursalService: null,
  tipoPagoService: null,
  metodoPagoService: null,
  pagoClienteService: null,
  ventaService: null,
  auth: null,
  created() {
    this.clienteService = new ClienteService()
    this.sucursalService = new SucursalService()
    this.tipoPagoService = new TipoPagoService()
    this.metodoPagoService = new MetodoPagoService()
    this.pagoClienteService = new PagoClienteService()
    this.ventaService = new VentaService()
    this.auth = useAuth()
  },
  mounted() {
    this.datos_necesarios_reporte_pagos()
  },
  methods: {
    onPageChange(event) {
      this.paginaActual = event.page + 1
      this.porPagina = event.rows
      this.enviando = true
      this.cargarPagoClientes()
    },
    anularDescuento(pagoCliente) {
      if (!this.puedeAnularDescuento(pagoCliente)) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Solo se puede anular el descuento después de la fecha límite',
          life: 3000
        })
        return
      }

      this.clienteSeleccionado = pagoCliente
      this.modalRecargoVisible = true
    },

    confirmarRecargo() {
      this.aplicandoRecargo = true
      this.pagoClienteService
        .anularDescuento(this.clienteSeleccionado.id)
        .then((response) => {
          if (response.success) {
            this.$toast.add({
              severity: 'success',
              summary: 'Recargo Aplicado',
              detail: response.message,
              life: 5000
            })
            this.modalRecargoVisible = false
            this.BuscarFiltro()
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Advertencia',
              detail: response.message,
              life: 3000
            })
          }
          this.aplicandoRecargo = false
        })
        .catch(() => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al aplicar recargo',
            life: 3000
          })
          this.aplicandoRecargo = false
        })
    },

    formatearFechaCorta(fecha) {
      if (!fecha) return '-'

      // Si la fecha viene con hora (2026-01-17 09:38:49), la limpiamos
      const soloFecha = fecha.split(' ')[0]
      const [year, month, day] = soloFecha.split('-')

      return `${day}/${month}/${year.slice(-2)}`
    },

    getEstadoVencimiento(fechaVencimiento) {
      if (!fechaVencimiento) return { severity: 'info', icon: '', tooltip: '' }

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)

      const [year, month, day] = fechaVencimiento.split('-')
      const fechaLimite = new Date(year, month - 1, day, 0, 0, 0)

      const diffMs = fechaLimite.getTime() - hoy.getTime()
      const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24))

      if (diffDias < 0) {
        return {
          severity: 'danger',
          icon: 'pi pi-exclamation-triangle',
          tooltip: '¡VENCIDO! hace ' + Math.abs(diffDias) + ' días'
        }
      } else if (diffDias === 0) {
        return {
          severity: 'warning',
          icon: 'pi pi-clock',
          tooltip: '¡Último día! Vence hoy a las 23:59'
        }
      } else if (diffDias <= 3) {
        return {
          severity: 'warning',
          icon: 'pi pi-clock',
          tooltip: '¡Por vencer! ' + diffDias + ' días restantes'
        }
      } else {
        return {
          severity: 'success',
          icon: 'pi pi-check-circle',
          tooltip: 'Vigente ' + diffDias + ' días restantes'
        }
      }
    },

    puedeAnularDescuento(pagoCliente) {
      if (!pagoCliente.descuento_condicional || !pagoCliente.fecha_limite_descuento) {
        return false
      }

      if (pagoCliente.recargo_incumplimiento > 0) {
        return false
      }

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)

      const [year, month, day] = pagoCliente.fecha_limite_descuento.split('-')
      const fechaLimite = new Date(year, month - 1, day, 23, 59, 59)

      return hoy.getTime() > fechaLimite.getTime()
    },

    enviarWhatsApp() {
      if (this.sucursalSelected === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Debe seleccionar una sucursal específica para enviar WhatsApp',
          life: 3000
        })
        return
      }

      const clientesPendientes = this.pago_clientes.filter((cliente) => cliente.estado === 2 && cliente.saldo > 0)

      if (clientesPendientes.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay clientes con pagos pendientes para enviar recordatorios',
          life: 3000
        })
        return
      }

      this.clientesValidosWhatsApp = clientesPendientes.filter((cliente) => {
        const telefono = cliente.telefono ? cliente.telefono.toString() : ''
        return telefono.length >= 8 && telefono.length <= 11
      })

      this.clientesSinTelefonoWhatsApp = clientesPendientes.filter((cliente) => {
        const telefono = cliente.telefono ? cliente.telefono.toString() : ''
        return !telefono || telefono.length < 8 || telefono.length > 11
      })

      if (this.clientesValidosWhatsApp.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay clientes con números de teléfono válidos para enviar mensajes',
          life: 3000
        })
        return
      }

      this.modalConfirmacionWhatsAppVisible = true
    },

    confirmarEnvioWhatsAppPagos() {
      this.enviando_whatsapp = true

      let datos = [...this.clientesValidosWhatsApp]

      this.pagoClienteService
        .enviarWhatsapp(datos)
        .then((response) => {
          this.modalConfirmacionWhatsAppVisible = false

          if (response.success == false) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 3000
            })
            this.enviando_whatsapp = false
            return
          } else {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: response.message,
              life: 6000
            })

            if (response.mensajes_no_enviados.length > 0) {
              this.$toast.add({
                severity: 'warn',
                summary: 'Advertencia',
                detail: 'Algunos mensajes no pudieron enviarse a: ' + response.mensajes_no_enviados.join(', '),
                life: 10000
              })
            }
            this.enviando_whatsapp = false
          }
        })
        .catch(() => {
          this.modalConfirmacionWhatsAppVisible = false
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocurrió un error al enviar los mensajes',
            life: 3000
          })
          this.enviando_whatsapp = false
        })
    },

    getEstadoVencimientoSeverity(fechaVencimiento) {
      if (!fechaVencimiento) return 'info'

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)

      const [year, month, day] = fechaVencimiento.split('-')
      const fechaLimite = new Date(year, month - 1, day, 0, 0, 0)

      const diffMs = fechaLimite.getTime() - hoy.getTime()
      const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24))

      if (diffDias < 0) {
        return 'danger'
      } else if (diffDias <= 3) {
        return 'warning'
      } else {
        return 'success'
      }
    },

    exportPagosClient() {
      if (this.pago_clientes.length > 0) {
        this.exportando = true
        let datos = {
          sucursal_id: this.sucursalSelected,
          cliente_id: this.clienteSelected,
          tipo_pago_id: this.tipoPagoSelected,
          metodo_pago_id: this.metodoPagoSelected,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          estado_pago: this.estadoSelected,
          provincia_id: this.provinciaSelected,
          usuario_id: this.usuarioSelected,
          vencimiento_filter: this.vencimientoSelected
        }
        this.pagoClienteService.exportarPagosClientes(datos).then(() => {
          this.exportando = false
          this.$toast.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Se exportó el reporte correctamente',
            life: 3000
          })
        })
      } else {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay datos para exportar',
          life: 3000
        })
        this.exportando = false
      }
    },

    datos_necesarios_reporte_pagos() {
      this.pagoClienteService
        .datos_necesarios_reporte_pagos()
        .then((data) => {
          this.sucursales = [{ id: 0, nombre: 'TODAS' }, ...(data.sucursales || [])]
          this.clientes = [{ id: 0, nombre: 'TODOS' }, ...(data.clientes || [])]
          this.tipo_pagos = [{ id: 0, nombre: 'TODOS' }, ...(data.tipo_pagos || [])]
          this.metodo_pagos = [{ id: 0, nombre: 'TODOS' }, ...(data.metodo_pagos || [])]
          this.provincias = [{ id: 0, nombre_municipio: 'TODAS' }, ...(data.provincias || [])]
          this.usuarios = [{ id: 0, name: 'TODOS' }, ...(data.usuarios || [])]
        })
        .catch((error) => {
          console.log(error)
        })
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2
      }).format(numero)
    },

    acciones(datos) {
      return [
        {
          label: 'Registrar Pago',
          disabled: datos.estado == 1,
          icon: 'pi pi-plus',
          command: () => {
            this.NuevoPagoCliente(datos)
          }
        },
        {
          label: 'Aplicar Recargo por Incumplimiento',
          visible: this.puedeAnularDescuento(datos),
          icon: 'pi pi-exclamation-triangle',
          command: () => {
            this.anularDescuento(datos)
          }
        },
        {
          label: 'Ver Detalle de Pago',
          icon: 'pi pi-eye',
          to: 'pago_clientes/' + datos.id + '/detalle'
        },
        {
          label: 'Imprimir Venta',
          icon: 'pi pi-print',
          command: () => {
            this.imprimirVenta(datos.venta_id)
          }
        }
      ]
    },

    estaVencido(fechaVencimiento) {
      if (!fechaVencimiento) return false

      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)

      const [year, month, day] = fechaVencimiento.split('-')
      const fechaLimite = new Date(year, month - 1, day, 23, 59, 59)

      return hoy.getTime() > fechaLimite.getTime()
    },

    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch((error) => console.log(error))
    },

    actualizarListado() {
      this.BuscarFiltro()
    },

    NuevoPagoCliente(datos) {
      this.pago_cliente = { ...datos }
      this.pagoClienteDialog = true
    },

    cerrarModalPagoCliente() {
      this.pagoClienteDialog = false
    },

    BuscarFiltro() {
      this.enviando_whatsapp = false
      this.pago_clientes = []
      this.enviando = true
      this.cargarPagoClientes()
    },

    cargarPagoClientes() {
      let datos = {
        sucursal_id: this.sucursalSelected == 0 ? null : this.sucursalSelected,
        cliente_id: this.clienteSelected,
        tipo_pago_id: this.tipoPagoSelected,
        metodo_pago_id: this.metodoPagoSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        estado: this.estadoSelected,
        provincia_id: this.provinciaSelected,
        usuario_id: this.usuarioSelected,
        vencimiento_filter: this.vencimientoSelected,
        page: this.paginaActual,
        per_page: this.porPagina
      }

      this.pagoClienteService
        .getAllPagoClientes(datos)
        .then((response) => {
          this.pago_clientes = response.pago_clientes
          this.totalRegistros = response.pagination.total

          this.enviando = false
        })
        .catch(() => {
          this.enviando = false
        })
    },

    estadoTexto(estado) {
      return estado === 1 ? 'PAGADO' : 'PENDIENTE'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}

/* TABLA MÁS COMPACTA CON MENOS PADDING */
.tabla-compacta::v-deep {
  .p-datatable-thead > tr > th {
    padding: 0.3rem 0.2rem;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .p-datatable-tbody > tr > td {
    padding: 0.25rem 0.2rem;
    font-size: 0.85rem;
  }

  .p-button-sm {
    padding: 0.25rem 0.4rem;
    font-size: 0.8rem;
  }
}

.texto-truncado {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 3px;
}
</style>
